import React from "react";
import { observer } from "mobx-react";
import { UserNotificationViewStore } from "../../store";
import { UserNotificationViewForm } from "./UserNotificationViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type UserNotificationViewProps = {
  userNotificationViewStore: UserNotificationViewStore;
};

export const UserNotificationView: React.FC<UserNotificationViewProps> =
  observer(({ userNotificationViewStore }) => {
    return (
      <div>
        <UserNotificationViewForm
          typeOptions={userNotificationViewStore.getTypeOptions()}
          type={userNotificationViewStore.typeValue}
          priorityOptions={userNotificationViewStore.getPriorityOptions()}
          priority={userNotificationViewStore.priorityValue}
          title={userNotificationViewStore.titleValue}
          body={userNotificationViewStore.bodyValue}
          actorUserValue={userNotificationViewStore.actorUserValue}
          objectType={userNotificationViewStore.objectTypeValue}
          objectId={userNotificationViewStore.objectIdValue}
          actionUrl={userNotificationViewStore.actionUrlValue}
          readAt={userNotificationViewStore.readAtValue}
          notificationCreatedAt={
            userNotificationViewStore.notificationCreatedAtValue
          }
          archivedAt={userNotificationViewStore.archivedAtValue}
          metadata={userNotificationViewStore.metadataValue}
          onPrint={(handlePrint: () => void) =>
            userNotificationViewStore.printUserNotification(handlePrint)
          }
          onCancel={() => userNotificationViewStore.cancelUserNotification()}
          onEdit={
            userNotificationViewStore.isEditEnabled
              ? () => userNotificationViewStore.editUserNotification()
              : undefined
          }
        />
        <ErrorDialog
          open={userNotificationViewStore.errorDialogOpened}
          title={userNotificationViewStore.errorTitle}
          description={userNotificationViewStore.errorDescription}
          onClose={() => userNotificationViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
